module.exports = __webpack_public_path__ + "static/media/welcome.03f02012.svg";